import { Component, h } from 'preact'
import axios from 'axios'
import EventCalendarRow from './EventCalendarRow'
import Phrase from '../../libs/translationsUtils/phrase'
import Icon from '../assets'

interface Event {
    id: number,
    type?: string,
    startAt: number,
    title: string,
    destinationUrl: string
}

interface State {
  eventsList: Array<Event>,
  isLoading: boolean
}

interface Props {
  maxResults: number,
  title: string,
  eventsList?: State['eventsList']
}

class EventsCalendarWidget extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      eventsList: props.eventsList || [],
      isLoading: false
    }
  }

  async componentDidMount () {
    if (this.state.eventsList.length) return
    this.setState({ isLoading: true })
    try {
      const res = await axios.get('/widget/eventsCalendar', {
        params: {
          maxResults: this.props.maxResults
        }
      })
      if (res.data) {
        this.setState({ eventsList: res.data, isLoading: false })
      }
    } catch (e) {
      this.setState({ isLoading: false })
    }
  }

  render (props: Props, state: State) {
    let eventsCount = state.eventsList.length
    let showTwoColumns = (eventsCount === 4 || eventsCount === 2)
    return (
      <div className='event-calendar-container'>
        { props.title && eventsCount > 0 ? <h3 class='widget-title widget__heading'>{ props.title } </h3> : '' }
        {
          state.isLoading ? '' : (eventsCount > 0 ? (
            <div className={`event-calendar-wrapper ${showTwoColumns ? 'event-calendar-wrapper-two-column' : 'event-calendar-wrapper-three-column'}`}>
              { state.eventsList.map(event => <EventCalendarRow {...event} />)}
            </div>
          ) : ''
          ) }
        {state.isLoading ? '' : (eventsCount > 0 ? (
            <div>
              <a href='/events' className='btn--cta btn--show-more'> <Phrase p='events.show.more' m='Forum' />
              <Icon customClass='btn--show-more-icon' icon='chevronRight' height={20} width={20} />
              </a>
            </div>) : '')}
      </div>
    )
  }
}

export default EventsCalendarWidget
